import * as actionTypes from "../actions/actionTypes";
import {USER_MANAGEMENT} from '../../../constants/comman'

const initalState: any = {
  usersData: null,
  allUsersdata: null,
  totalPages: 1,
  subjectList: {},
  courseList: {},
  selectedTab: "",
  userAddedSuccessfully: false,
  userEditedSuccessfully: false,
  formErrors: null,
  user: null,
  isSetRoles: false,
  isSetUsers: false,
  isSetClients: false,
  usersSearch: null,
  usersChips: [],
  usersSearchActiveOption: USER_MANAGEMENT.USERS.USER_DETAILS,
  usersSearchData: {
    status: "",
    userDetails: [],
    clients: [],
    roles: [],
  },
};

const usersReducers = (state = initalState, action: any) => {
  switch (action.type) {
    case actionTypes.GET_USERS_REQUEST:
      return {
        ...state,
      };

    case actionTypes.GET_USERS_SUCCESS:
      return {
        ...state,
        usersData: action.payload.users,
        totalPages: action.payload.totalPages ? action.payload.totalPages : state.totalPages,
        allUsersdata: action.payload
      };
    case actionTypes.GET_SUBJECT_LIST_SUCCESS:
      return {
        ...state,
        subjectList: action.payload,
      };
      case actionTypes.GET_COURSE_LIST_SUCCESS:
        let list = action.payload;
        list = list && list.map((ele: any) => {
          ele.name = ele.name + ' | ' + ele.sku
          return ele
        })
        return {
          ...state,
          courseList: action.payload,
        };
    case actionTypes.SWITCH_SELECTED_TAB_SUCCESS:
      return {
        ...state,
        selectedTab: action.payload,
      };
    case actionTypes.SET_ROLES_TAB:
      return {
        ...state,
        isSetRoles: action.payload,
        isSetUsers: false,
        isSetClients: false
      };
    case actionTypes.SET_USERS_TAB:
      return {
        ...state,
        isSetRoles: false,
        isSetClients: false,
        isSetUsers: action.payload,
      };
    case actionTypes.SET_CLIENTS_TAB: 
    return {
      ...state,
      isSetClients: action.payload,
      isSetRoles: false,
      isSetUsers: false,
    };
    case actionTypes.ADD_USER_FAILURE: {
      let updatedFormErrors = {
        name: "",
        role: "",
        fullName: "",
        email: "",
        number: "",
        empCode: "",
      };
      if (action.payload.responseObject.message.includes("license")) {
        updatedFormErrors.name = action.payload.responseObject.message;
      }
      if (
        action.payload.responseObject.message.includes(
          "Email Id already exists for another user"
        )
      ) {
        updatedFormErrors.email = action.payload.responseObject.message;
      } else if (action.payload.responseObject.message.includes('Username already exists')) {
        updatedFormErrors.fullName = action.payload.responseObject.message;
      } else if (action.payload.responseObject.message.includes('Mobile number already in use')) {
        updatedFormErrors.number = action.payload.responseObject.message;
      } else if (action.payload.responseObject.message.includes('Employee code already in use')) {
        updatedFormErrors.empCode = action.payload.responseObject.message;
      }

      return {
        ...state,
        formErrors: updatedFormErrors,
        userAddedSuccessfully: false,
      };
    }
    case actionTypes.ADD_USER_SUCCESS:
      return {
        ...state,
        userAddedSuccessfully: true,
      };
    case actionTypes.ADD_USER_TOAST_CLOSE:
      return {
        ...state,
        userAddedSuccessfully: false,
        userEditedSuccessfully: false
      };
    case actionTypes.GET_USER_SUCCESS:
      return {
        ...state,
        user: action.payload,
      };
    case actionTypes.EDIT_USER_SUCCESS: {
      return {
        ...state,
        userAddedSuccessfully: false,
        userEditedSuccessfully: true
      };
    }
    case actionTypes.EDIT_USER_FAILURE: {
      let updatedFormErrors = {
        name: "",
        role: "",
        fullName: "",
        email: "",
        number: ""
      };
      if (
        action.payload.responseObject.message.includes(
          "Already exists for another user"
        )
      ) {
        updatedFormErrors.email = "Already exists for another user";
      }
      return {
        ...state,
        formErrors: updatedFormErrors,
        userEditedSuccessfully: false
      };
    }
    case actionTypes.SEARCH_USERS_SUCCESS:
      return {
        ...state,
        usersData: action.payload.res.users,
        usersSearch: action.payload.requestObject,
        totalPages: action.payload.res.totalPages
      }
    
    case actionTypes.SET_USERS_SEARCH_ACTIVE_OPTION_SUCCESS:
      const udpatedUsersSearchActiveOption = action.payload.value;
      return {
        ...state,
        usersSearchActiveOption: udpatedUsersSearchActiveOption,
      }

    case actionTypes.ADD_USERS_CHIP_SUCCESS:
      const newChip = action.payload;
      const updatedUsersChips = state.usersChips;
      if(updatedUsersChips.includes(newChip)){
        return state;
      }
      updatedUsersChips.push(newChip);
      const updatedUsersSearchData = state.usersSearchData;
      if(state.usersSearchActiveOption === USER_MANAGEMENT.USERS.USER_DETAILS){
        updatedUsersSearchData.userDetails.push(newChip);
      }
      else if(state.usersSearchActiveOption === USER_MANAGEMENT.USERS.ROLES){
        updatedUsersSearchData.roles.push(newChip);
      }
      else if(state.usersSearchActiveOption === USER_MANAGEMENT.USERS.CLIENTS){
        updatedUsersSearchData.clients.push(newChip);
      }
      else{
        updatedUsersSearchData.status = newChip;
      }

      return{
        ...state,
        usersChips: updatedUsersChips,
        usersSearchData: updatedUsersSearchData
      }
    
    case actionTypes.REMOVE_USERS_CHIP_SUCCESS:
      let chipToRemove = action.payload
      let updatedUserChips = state.usersChips;
      updatedUserChips = updatedUserChips.filter((userChip: string) => userChip !== chipToRemove);

      let updatedUsersSearchDataRemoveCase = state.usersSearchData;
      let updatedUserDetails = state.usersSearchData.userDetails;
      let updatedClients = state.usersSearchData.clients;
      let updatedRoles = state.usersSearchData.roles;

      updatedUserDetails = updatedUserDetails.filter((role: string) => role !== chipToRemove);
      updatedRoles = updatedRoles.filter((role: string) => role !== chipToRemove);
      updatedClients = updatedClients.filter((client: string) => client !== chipToRemove);

      updatedUsersSearchDataRemoveCase.roles = updatedRoles;
      updatedUsersSearchDataRemoveCase.clients = updatedClients;
      updatedUsersSearchDataRemoveCase.userDetails = updatedUserDetails;
      if(chipToRemove === USER_MANAGEMENT.USERS.ACTIVE || chipToRemove === USER_MANAGEMENT.USERS.INACTIVE){
        updatedUsersSearchDataRemoveCase.status = '';
      }

      if (!updatedUserChips.length) {
        updatedUsersSearchDataRemoveCase = {
          status: "",
          userDetails: [],
          clients: [],
          roles: [],
        };
      }
      return {
        ...state,
        usersChips: updatedUserChips,
        usersSearchData: updatedUsersSearchDataRemoveCase
      }

    default:
      return state;
  }
};

export default usersReducers;
